import Vue from 'vue';
import {firestore} from '@/firebase.js';
export default {
    state:{
      empresa:{
        logo:""
      }
    },
    mutations: {
      setEmpresa(state,empresa){
        state.empresa=empresa;
      },
    },
    actions: {
      Actualizar_Empresa(context){
        console.log('Actualizar_Empresa', context.rootState.cia.cia.firebase_firestor);
        firestore.collection("empresas").doc(context.rootState.cia.cia.firebase_firestore)
        .get()
        .then(function(doc) {
          console.log(doc.data());
          context.commit('setEmpresa',doc.data());
        })
        .catch(function(error) {
          console.log("Error modulo empresa 'Actualizar_Empresa'", error);
        });
      },
    },
    getters: {
      getEmpresa(state){
        return state.empresa;
      },
    },

}


// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/src/modules/empresa.js